import * as React from "react";
import { FormikErrors, Formik, Field } from "formik";
import { ParticipantAuthentication, SecureMessageStep } from "../types";
import FormikPin from "../../../components/form/FormikPin";
import * as Yup from "yup";

interface Props {
  setSecureMessageStep: (step: SecureMessageStep) => void;
  authenticateParticipant: (
    params: ParticipantAuthentication,
    onError: (error: FormikErrors<ParticipantAuthentication>) => void
  ) => void;
  forgotPin: () => void;
  errorMessage: string;
}

class ValidatePassword extends React.PureComponent<Props> {
  public passwordRef: any;

  public constructor(props: Props) {
    super(props);

    this.passwordRef = React.createRef();
  }

  private getInitialValues = (): ParticipantAuthentication => {
    return {
      password: ""
    };
  };

  componentDidMount() {
    this.passwordRef.current.focus();
  }

  public componentDidUpdate(prevProps: Props) {
    if (prevProps.errorMessage !== this.props.errorMessage) {
      this.setState({ password: "" });
    }
  }

  public render() {
    return (
      <div className="prompt">
        <div className="small">To verify your identity, </div>
        <div className="mt-5 bold mb-20">Please enter your passcode</div>

        <Formik
          initialValues={this.getInitialValues()}
          onSubmit={async (values, form) => {
            this.props.authenticateParticipant(values, form.setErrors);
            this.passwordRef.current.clear();
          }}
          validationSchema={Yup.object().shape({
            password: Yup.string().required("PIN is required")
          })}
        >
          {props => {
            const { dirty, initialTouched, isSubmitting, isValid, handleSubmit } = props;

            return (
              <form onSubmit={handleSubmit}>
                <div className="flex-column-center">
                  <Field
                    name="password"
                    component={FormikPin}
                    onComplete={handleSubmit}
                    innerRef={this.passwordRef}
                  />
                  {this.props.errorMessage && (
                    <div className="formik-error center mt-10">{this.props.errorMessage}</div>
                  )}

                  <button
                    type="submit"
                    className={"full-width mt-25 " + (dirty && isValid ? "highlight" : "")}
                    disabled={!initialTouched || !dirty || !isValid || isSubmitting}
                  >
                    Continue
                  </button>
                </div>
              </form>
            );
          }}
        </Formik>

        <button className="btn-link mt-20" id="forgot-pin-button" onClick={this.props.forgotPin}>
          Forgot PIN
        </button>
      </div>
    );
  }
}

export default ValidatePassword;
